import { Component } from "@angular/core";

@Component({
	selector: "f-semantic",
	templateUrl: "./component.html",
	styleUrls: ["./component.scss"]
})
export class SemanticComponent {}
